<template>
    <v-dialog
        v-model="e.show"
        max-width="500"
    >
        <v-card>
            <v-card-title class="headline">{{e.title}}</v-card-title>

            <v-card-text>
                {{e.text}}
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    :color="e.color"
                    @click="e.action"
                >
                    {{e.actionText}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ErrorDialog',
    computed: {
        e() {
            return this.$store.state.errorDialog;
        }
    }
}
</script>
